import { render, staticRenderFns } from "./Index.vue?vue&type=template&id=5e2f2295"
import script from "@/controllers/admin/user/Index?vue&type=script&lang=ts&external"
export * from "@/controllers/admin/user/Index?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports